import * as React from 'react';

/* eslint-disable spellcheck/spell-checker */
function WarningExclamantionCircle() {
    return (React.createElement("svg", { height: "20", viewBox: "0 0 20 20", width: "20", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M20 10c0 5.524-4.478 10-10 10S0 15.524 0 10C0 4.48 4.478 0 10 0s10 4.48 10 10zm-10 2.016a1.855 1.855 0 100 3.71 1.855 1.855 0 000-3.71zM8.239 5.35l.3 5.484a.484.484 0 00.482.457h1.958c.257 0 .469-.2.483-.457l.299-5.484a.484.484 0 00-.483-.51H8.722a.484.484 0 00-.483.51z", fill: "#E17A17", fillRule: "evenodd" })));
}
/* eslint-enable spellcheck/spell-checker */

export { WarningExclamantionCircle as default };
//# sourceMappingURL=WarningExclamationCircle.esm.js.map
